import React, {createContext, useContext, useReducer} from "react";

export const OPEN_DRAWER = 'drawer/open';
export const CLOSE_DRAWER = 'drawer/close';
export const SET_VIEW = 'drawer/set_view';

const DrawerContext = createContext(undefined);
const DrawerDispatchContext = createContext(undefined);

const initialState = {
    isOpen: false,
    view: undefined
};

const drawerReducer = (state, action) => {
    const {type, view} = action;
    switch (type) {
        case SET_VIEW:
            return {
                ...state,
                view: view
            };
        case OPEN_DRAWER:
            return {
                isOpen: true,
                view: view
            };
        case CLOSE_DRAWER:
            return {
                isOpen: false,
                view: view
            }
        default:
            throw new Error(`Unhandled action type: ${action.type}`);
    }
};

export const DrawerProvider = ({children}) => {
    const [state, dispatch] = useReducer(drawerReducer, initialState, undefined);
    return (
        <DrawerContext.Provider value={state}>
            <DrawerDispatchContext.Provider value={dispatch}>
                {children}
            </DrawerDispatchContext.Provider>
        </DrawerContext.Provider>
    );
};

export const useDrawerState = () => {
    const context = useContext(DrawerContext);
    if (undefined === context) {
        throw new Error("useDrawerState must be used within a DrawerProvider");
    } else {
        return context;
    }
};

export const useDrawerDispatch = () => {
    const context = useContext(DrawerDispatchContext);
    if (undefined === context) {
        throw new Error("useDrawerDispatch must be used withing a DrawerProvider");
    } else {
        return context;
    }
};
